(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('slick-carousel');

	$('[data-slideshow]').each(function () {
		var wrap = $(this);
		var slides = wrap.find('> *');
		var autoplay = wrap[0].hasAttribute('data-slideshow-autoplay') ? true : false;
		var numSlides = wrap.attr('data-slideshow');
			numSlides = numSlides ? parseInt(numSlides) : 1;

		if (window.matchMedia('(max-width: 759px)').matches) {
			numSlides = 1;
		}

		if (slides.length > numSlides) {
			wrap.slick({
				dots: true,
				arrows: true,
				slidesToShow: numSlides,
				slidesToScroll: numSlides,
				infinite: true,
				speed: 400,
				autoplay: autoplay,
				autoplaySpeed: 3000,
				adaptiveHeight: true,
				prevArrow: '<a role="button" class="slick-prev icon-left icon--round icon--round--ghost"></a>',
				nextArrow: '<a role="button" class="slick-next icon-right icon--round icon--round--ghost"></a>'
			});
		}
	});

	$('[data-slideshow-nav-for]').each(function () {
		var nav = $(this);
		var slideshow = $(nav.attr('data-slideshow-nav-for'));

		slideshow.on('beforeChange', function (e, slick, curr, next) {
			nav.find('li').removeClass('active').eq(next).addClass('active');
		});

		nav.find('li').each(function (i) {
			$(this).click(function () {
				slideshow.slick('slickGoTo', i);
			});
		}).eq(0).addClass('active');
	});
})();
